import { Button, DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutDistanceRateTableList extends Layout {
    buttonCopy: Button;
    layoutheaderDistanceRateTable: LayoutHeader;
    sourceRateHeaderLookup: DataSource;
    tableDistanceRateTables: Table;
}
